import {Injectable} from "@angular/core";
import {HttpObservable, HttpWrapper} from "../../http-helpers/http.wrapper";
import {IVersionDetails} from "../interfaces/version.details";

@Injectable({
  providedIn: "root"
})
export class VersionDetailsProxy {

  private readonly PATIENT_PORTAL_CLIENT_ID = 2;

  constructor(private httpWrapper: HttpWrapper) {
  }

  public getVersionDetails(): HttpObservable<IVersionDetails> {
    return this.httpWrapper.getAnon("VersionDetails", "GetVersionDetails", {pName: 'clientId', pVal: this.PATIENT_PORTAL_CLIENT_ID} );
  }
}
